import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { supabase } from "@/integrations/supabase/client";

/**
 * The signed-in person's profile types (renter, owner, …), read once and
 * shared. The navbar, the bottom nav and the command palette each used to
 * ask the database for it on every page load.
 */
export function useUserTypes() {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ["user_types", user?.id ?? null],
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    queryFn: async (): Promise<string[]> => {
      if (!user) return [];
      const { data: row } = await supabase.from("profiles").select("user_types").eq("user_id", user.id).maybeSingle();
      return ((row?.user_types as string[] | null) ?? []).slice();
    },
  });
  const userTypes = user ? (data ?? []) : [];
  return { userTypes, isOwner: userTypes.includes("owner") || userTypes.includes("property_manager") };
}
